import React from 'react';
import { Box } from '@mui/material';
import { StyledSwitch } from './Style/ToggleSwitch.style';

interface ToggleContentSwitchProps {
  checked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ToggleSwitch: React.FC<ToggleContentSwitchProps> = ({
  checked,
  handleChange,
}) => {
  return (
    <Box>
      <StyledSwitch
        data-testid="toggle-switch"
        checked={checked}
        onChange={handleChange}
        name="checked"
        inputProps={{ 'aria-label': 'secondary checkbox' }}
      />
    </Box>
  );
};

export default ToggleSwitch;
